module.exports = __webpack_public_path__ + "img/iss-plavi.909c042b.svg";